var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { AuthSource } from "../../authorization/structures.js";
import { Resource } from "../resources/Resource.js";
let AuthIdPairResource = class AuthIdPairResource extends Resource {
    source;
    value;
    init(init) {
        this.source = init.source;
        this.value = init.value;
    }
};
__decorate([
    Field(() => AuthSource, { nullable: false }),
    __metadata("design:type", String)
], AuthIdPairResource.prototype, "source", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], AuthIdPairResource.prototype, "value", void 0);
AuthIdPairResource = __decorate([
    ObjectType()
], AuthIdPairResource);
export { AuthIdPairResource };
//# sourceMappingURL=AuthIdPair.js.map